<template>
  <v-expansion-panels
    v-bind="$attrs"
    class="ekitabu-expansion-panels"
    :class="{ 'rounded-lg elevation-4': gradient }"
    v-on="$listeners"
  >
    <v-expansion-panel
      class="pa-0"
      :class="{ 'rounded-lg': gradient }"
    >
      <v-expansion-panel-header
        class="text-caption font-weight-bold"
        :class="{ 'primary-gradient rounded-lg border-sm border-footerBackground': gradient }"
        expand-icon="mdi-menu-down"
      >
        {{ title }}
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <slot />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
// Deprecated: opinionated title/gradient panel kept only for its existing
// consumers (BookDetails.vue, OrderComplete.vue). New usage should use the
// transparent EkitabuExpansionPanel instead.
export default {
  name: "EkitabuExpansionPanelDeprecated",
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      default: "",
    },
    gradient: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
